export default "__VITE_ASSET__BlirSNmz__"